( function() {
	'use strict';

	function init() {
		const on = ( selector, eventName, handler ) => {
			document.body.addEventListener( eventName, function( event ) {
				const target = event.target;
				if ( !( target instanceof Element ) ) {
					return;
				}
				const match = target.closest( selector );
				if ( match ) {
					handler( event, match );
				}
			} );
		};

		const visible = ( el ) => !!el && !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );

		const isViewMoreContainerEmpty = ( container ) => {
			if ( ! container ) {
				return true;
			}
			return ( container.textContent || '' ).replace( /\s+/g, ' ' ).trim() === '';
		};

		const syncViewMoreToggleForCard = ( card ) => {
			if ( ! card ) {
				return;
			}
			const viewMoreContainer = card.querySelector( '.view-more-container' );
			const toggle = card.querySelector( '.toggle-view-more' );
			if ( ! toggle ) {
				return;
			}
			const empty = isViewMoreContainerEmpty( viewMoreContainer );
			toggle.hidden = empty;
			if ( empty ) {
				toggle.classList.add( 'collapsed' );
				toggle.setAttribute( 'aria-expanded', 'false' );
				if ( viewMoreContainer ) {
					viewMoreContainer.classList.add( 'collapse' );
				}
			}
		};

		const syncViewMoreToggles = ( root = document ) => {
			root.querySelectorAll( '.card' ).forEach( syncViewMoreToggleForCard );
		};

		syncViewMoreToggles();
		document.addEventListener( 'colibri:products-updated', () => {
			syncViewMoreToggles();
		} );

		if ( location.href.indexOf( 'member-upg=1' ) !== - 1 ) {
			/**
			 * if running membership upgrade test (done for Elite on 7/22/2022)
			 * fetch membership status on hover
			 */
			document.querySelectorAll( '.grid-col > .card' ).forEach( ( card ) => {
				card.addEventListener( 'mouseenter', function() {
					const addToCart = card.querySelector( ':scope > [data-product-code]' );
					if (
						addToCart &&
						!addToCart.upsell &&
						!addToCart['is-checking-upsell']
					) {
						addToCart.dispatchEvent(
							new CustomEvent( 'UPDATE_ADD_TO_CART_BUTTON', {
								detail: {
									productCode:
										addToCart.dataset.productCode ||
										addToCart.getAttribute( 'data-product-code' ),
								},
								bubbles: true,
							} ),
						);
					}
				} );
			} );
		}

		/**
		 * Insert a general template for modal (if it is not there yet).
		 *
		 * This is needed to support a general-purpose modal
		 * @note we exclude map modals
		 */
		if ( !document.querySelector( 'body > .modal:not(.modal--map)' ) ) {
			const modal = document.createElement( 'div' );
			modal.className = 'modal';
			modal.tabIndex = -1;
			modal.setAttribute( 'role', 'dialog' );
			modal.innerHTML =
				'<div class="modal-dialog modal-dialog-centered" role="document">' +
				'<div class="modal-content">' +
				'<div class="modal-header">' +
				'<h5 class="modal-title"></h5>' +
				'<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Close">' +
				'<span aria-hidden="true">&times;</span>' +
				'</button>' +
				'</div>' +
				'<div class="modal-body"></div>' +
				'</div>' +
				'</div>';
			document.body.appendChild( modal );
		}

		/**
		 * Pop up modals when a link with rel="modal" is clicked
		 */
		// on( '[rel="modal"]', 'click', ( e, target ) => {

		// 	console.log( e, target );

		// 	if ( e.defaultPrevented ) {
		// 		return;
		// 	}

		// 	const card = target.closest( '.card--square' );

		// 	if (
		// 		!card ||
		// 		![ 'sellable_done', 'enrollable_done' ].includes(
		// 			card.getAttribute( 'data-product-status' ) || '',
		// 		)
		// 	) {
		// 		//the regular QuickView modal will be displayed by the global modal logic in cds-modal.js
		// 		return;
		// 	}

		// 	const addToCart = card.querySelector( '[data-product-code]' );

		// 	if ( !addToCart ) {
		// 		return;
		// 	}

		// 	const productStatus = card.getAttribute( 'data-product-status' ) || '';

		// 	const isProductAction = target.matches( '[data-legacy-add-to-cart]' ) || target.matches( '[data-core-add-to-cart]' );

		// 	/**
		// 	 * found addToCard button, so this is a card and we need to support Quick View modal
		// 	 */
		// 	if (
		// 		( target.matches( '.card--square' ) || target.matches( '.mode-cta' ) ) &&
		// 		[ 'sellable_done', 'enrollable_done' ].includes( productStatus )
		// 	) {
		// 		e.preventDefault();
		// 		const ctaSelector = 'sellable_done' === productStatus ? 'data-checkout-url' : 'data-dashboard-url';
		// 		const url = card.querySelector( '[' + ctaSelector + ']' )?.getAttribute( ctaSelector ) ?? '';
		// 		if ( url ) {
		// 			window.location.href = url;
		// 		} else {
		// 			console.error( 'No URL found for product', productCode );
		// 		}
		// 		return;
		// 	} else if ( !addToCart.querySelector( ':scope > .is-unknown-state' ) ) {
		// 		/**
		// 		 * do not call up the modal if this click is processed already
		// 		 */
		// 		if ( target.closest( '[data-legacy-add-to-cart]' ) || target.closest( '[data-core-add-to-cart]' ) ) {
		// 			if ( target !== addToCart && target.querySelector( 'button' ) ) {
		// 				target.querySelector( 'button' ).click();
		// 			} else if ( target.querySelector( 'a[href]' ) ) {
		// 				window.location.href = target.querySelector( 'a[href]' ).getAttribute( 'href' );
		// 			}
		// 			e.preventDefault();
		// 			return;
		// 		}
		// 	} //end of

		// 	e.preventDefault();
		// } );
		on( '.card .toggle-view-more[aria-expanded="false"]', 'click', ( e, target ) => {
			const card = target.closest( '.card' );
			const viewMoreContainer = card ? card.querySelector( '.view-more-container' ) : null;
			if ( isViewMoreContainerEmpty( viewMoreContainer ) ) {
				syncViewMoreToggleForCard( card );
				return;
			}
			if ( target.classList.contains( 'collapsed' ) ) {
				const toggle = target.closest( '.toggle-view-more' );
				if ( toggle ) {
					toggle.classList.remove( 'collapsed' );
				}
				if ( viewMoreContainer && viewMoreContainer.classList.contains( 'collapse' ) ) {
					viewMoreContainer.classList.toggle( 'collapse' );
				}
			} else {
				const toggle = target.closest( '.toggle-view-more' );
				if ( toggle ) {
					toggle.classList.add( 'collapsed' );
				}
				if ( viewMoreContainer && !viewMoreContainer.classList.contains( 'collapse' ) ) {
					viewMoreContainer.classList.toggle( 'collapse' );
				}
			}

			const addToCart = card ? card.querySelector( '[data-product-code]' ) : null;
			const productCode = addToCart
				? addToCart.dataset.productCode || addToCart.getAttribute( 'product-code' )
				: null;
			if ( productCode ){
				window.colibri.utils.pushAnalyticsData( productCode, 'view_item' );
			}
		} );

		on( '.pricing-container .switch input', 'change', function( e, input ) {
			const container = input.closest( '.pricing-container' );
			if ( !container ) {
				return;
			}
			const allInners = Array.from( container.querySelectorAll( '.pricing-inner' ) );
			const inner = allInners.find( ( el ) => visible( el ) );
			let invisible = allInners.find( ( el ) => !visible( el ) );

			if ( !invisible && inner ) {
				const next = inner.nextElementSibling;
				const doc = next?.contentDocument || next?.contentWindow?.document;
				const fetched = doc ? doc.querySelector( '.pricing-inner' ) : null;
				if ( fetched ) {
					invisible = fetched.cloneNode( true );
					inner.insertAdjacentElement( 'afterend', invisible );
				}
			}

			if ( inner ) {
				inner.style.display = 'none';
			}
			if ( invisible ) {
				invisible.style.display = '';
			}

			//update CTAs on the parent card
			const productNew = invisible
				? invisible.dataset.productCode || invisible.getAttribute( 'data-product-code' )
				: null;
			const payTerm = invisible ? invisible.querySelector( '.payment-term' ) : null;
			const payOptNew = payTerm
				? payTerm.dataset.paymentOptionId || payTerm.getAttribute( 'data-payment-option-id' )
				: null;

			container.closest( '.card' )?.querySelectorAll( '[data-product-code]' ).forEach( ( el ) => {
				//We should check if product is available or in the cart already.
				//note we set "alt-*" to preserve the original product code, because it can be used for indexing DOM elements.
				el.dataset.altPaymentOptionId = payOptNew || '';
				el.dataset.altProductCode = productNew || '';
				window.dispatchEvent(
					new CustomEvent( 'ColibriEvent:INIT_ADD_TO_CART', {
						detail: el,
					} ),
				);
			} );
		} );

		on( '.modal-body .payment-options button', 'click', function( e, button ) {

			// function readCookie( name ) {
			// 	const nameEQ = name + '=';
			// 	const ca = document.cookie.split( ';' );
			// 	for ( let i = 0; i < ca.length; i ++ ) {
			// 		let c = ca[ i ];
			// 		while ( c.charAt( 0 ) === ' ' ) {
			// 			c = c.substring( 1, c.length );
			// 		}
			// 		if ( c.indexOf( nameEQ ) === 0 ) {
			// 			return c.substring( nameEQ.length, c.length );
			// 		}
			// 	}
			// 	return null;
			// }

			function setCookie( name, value, days ) {
				var expires = "";
				if ( days ) {
					var date = new Date();
					date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
					expires = "; expires=" + date.toUTCString();
				}

				var temp = location.host;
				temp = temp ? temp.split('.') : '';
				temp = temp ? temp.reverse() : '';
				temp = temp ? '.' + temp[1] + '.' + temp[0] : '';

				const domain = temp ? '; domain=' + temp : '';

				document.cookie = name + "=" + (value || "")  + expires + domain + "; path=/";
			}

			function deleteCookie(name){
				document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			}

			const prodCode = button.dataset.productCode;
			const planId = button.dataset.paymentOptionId;
			const partnerId = button.dataset.partnershipId;
			const partnerGroupItemId = button.dataset.partnershipGroupItemId ?? 0;

			if ( partnerId ) {
				setCookie( 'STYXKEY-partnershipid', partnerId, 1 );
			} else {
				deleteCookie( 'STYXKEY-partnershipid' );
			}

			let url = window.colibri.studentApi + '/cart/items.json?searchResultId=' + prodCode;

			//we would get this from product status check
			// url += enrollmentId
			// 	   ? '&enrollmentId=' + enrollmentId
			// 	   : '';

			url += planId
				   ? '&paymentOptionId=' + planId
				   : '';

			url += partnerGroupItemId
				   ? '&PartnershipGroupItemId=' + partnerGroupItemId
				   : '';

			url += '&addedFrom=PaymentPlanModal';

			fetch( url, {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			} )
				.then( () => {
					window.location.href = window.colibri.cartUrl;
				} )
				.catch( () => true );
		} );

		// Align buttons on packages when Affirm text is loaded
		function addAffirmClass() {
			const affirmBlock = document.querySelector( '.affirm-as-low-as' );

			if (!affirmBlock) {
				return;
			}

			const priceElements = document.querySelectorAll( '.card .price' );

			function updatePriceElements() {
				priceElements.forEach( function ( element ) {
					element.classList.add('has-affirm');
				} );
			}

			// Check if Affirm block is updated based on location
			const mutationCallback = function ( mutationsList ) {
				for ( const mutation of mutationsList ) {
					if ( mutation.type === 'childList' && mutation.target.classList.contains( 'affirm-as-low-as' ) ) {
						updatePriceElements();
					}
				}
			};

			const observer = new MutationObserver( mutationCallback );
			const observerConfig = { childList: true, subtree: true };

			observer.observe( affirmBlock, observerConfig );
		}

		addAffirmClass();

	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}

} )();
